import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadPageSeo } from "./seoApi";
import { appBasename } from "./config/api";

function normalizeRoute(route) {
  const cleaned = route.trim();
  if (cleaned === "" || cleaned === "/") {
    return "/";
  }

  const parsed = new URL(cleaned, "http://example.com").pathname;
  const path = parsed === "" ? "/" : parsed;
  return path !== "/" ? path.replace(/\/+$/, "") : "/";
}

function stripBaseName(pathname) {
  const base = appBasename();
  if (base && pathname.startsWith(base)) {
    return pathname.slice(base.length) || "/";
  }
  return pathname;
}

function setMetaTag(name, content) {
  const existing = document.querySelector(`meta[name="${name}"]`);
  if (existing) {
    existing.setAttribute("content", content);
    return;
  }

  const element = document.createElement("meta");
  element.setAttribute("name", name);
  element.setAttribute("content", content);
  document.head.appendChild(element);
}

function updateMeta(meta) {
  if (meta.title !== undefined && meta.title !== "") {
    document.title = meta.title;
  }

  if (meta.description !== undefined) {
    setMetaTag("description", meta.description || "");
  }

  if (meta.keywords !== undefined) {
    setMetaTag("keywords", meta.keywords || "");
  }
}

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const route = normalizeRoute(stripBaseName(location.pathname));

    if (route.startsWith("/admin")) {
      return undefined;
    }

    let cancelled = false;

    loadPageSeo(route)
      .then((data) => {
        if (!cancelled && data?.meta) {
          updateMeta(data.meta);
        }
      })
      .catch(() => {
        // Silence SEO failures so routing and page render remain unaffected.
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  return null;
}
